import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

import LogoSVG from '../images/logo.svg'

const Header = styled.header`
  width: 100%;
  padding: 1.5em 0;
  border-bottom: solid 2px ${props => props.theme.colors.base};
`

const Logo = styled.div`
  @media (max-width: ${props => props.theme.responsive.small}) {
    margin-bottom: 20px;
  }
`

const LinkWrap = styled.div`
  overflow: auto;
  display: flex;
  padding-bottom: 0.5rem;
  margin-top: 0.5rem;
`

const Nav = styled.nav`
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 0 1.5em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.responsive.small}) {
    justify-content: center;
  }
  & > div {
    display: inline-flex;
  }

  ul {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  li {
    display: inline-block;
    white-space: nowrap;
    /* margin-left: 1em; */
    &:first-child {
      position: relative;
      margin: 0;
      flex-basis: 100%;
    }
  }

  a {
    text-decoration: none;
    color: DarkGray;
    font-weight: 400;
    margin: 0 10px;
    transition: all 0.2s;
    &:hover {
      color: ${props => props.theme.colors.base};
    }
  }
`

const activeLinkStyle = {
  color: '#1cb2bf',
}

const Menu = () => {
  return (
    <Header>
      <Nav>
        <Logo>
          <Link to="/">
            <img style={{ width: 150 }} src={LogoSVG} alt="logo" />
          </Link>
        </Logo>
        <LinkWrap>
          <ul>
            <li>
              <Link to="/what/" activeStyle={activeLinkStyle}>
                What We Do
              </Link>
            </li>
            <li>
              <Link to="/how-we-do-it/" activeStyle={activeLinkStyle}>
                How We Do It
              </Link>
            </li>
            <li>
              <Link to="/contact/" activeStyle={activeLinkStyle}>
                Contact
              </Link>
            </li>
          </ul>
        </LinkWrap>
      </Nav>
    </Header>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js